import React from 'react';
import IconButton from '../../Buttons/IconButton';
import ArrowLeft from '../../Icons/16x16/ArrowLeft';
import Close from '../../Icons/24x24/Close';
import PopoverHeadingText from '../PopoverHeadingText';
import SpreadLayout from '../SpreadLayout';
import s from './PopoverHeader.scss';
/** A wrapper around left-side items to help keep the main component body clean */
var LeftItem = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: s['left-item-wrapper'] }, children));
};
/** Our standard Popover header. */
var PopoverHeader = function (_a) {
    var heading = _a.heading, illustration = _a.illustration, onBackClick = _a.onBackClick, onCloseClick = _a.onCloseClick, className = _a.className;
    return (React.createElement(SpreadLayout, { className: className, left: [
            onBackClick && (React.createElement(LeftItem, { key: "back-button" },
                React.createElement(IconButton, { key: "back-button", icon: ArrowLeft, size: "small", onClick: onBackClick }))),
            illustration && React.createElement(LeftItem, { key: "illustration" }, illustration),
            React.createElement(LeftItem, { key: "heading" },
                React.createElement(PopoverHeadingText, null, heading)),
        ], right: onCloseClick && (React.createElement(IconButton, { icon: Close, size: "medium", onClick: onCloseClick })) }));
};
PopoverHeader.displayName = 'PopoverHeader';
export default PopoverHeader;
//# sourceMappingURL=PopoverHeader.js.map